import {useMemo} from "react";
import {useTranslation} from "react-i18next";

export const useFormField = ({editor, hideWhenUnavailable = false, onInserted}) => {
  const {t} = useTranslation();

  const isVisible = useMemo(() => {
    if (!editor) return false;
    if (!hideWhenUnavailable) return true;

    return editor.can().chain().focus().insertFormField().run();
  }, [editor, hideWhenUnavailable]);

  const canInsert = useMemo(() => {
    if (!editor || !editor.isEditable) return false;
    return editor.can().chain().focus().insertFormField().run();
  }, [editor]);

  const isActive = useMemo(() => {
    if (!editor) return false;
    return editor.isActive("formField");
  }, [editor]);

  const handleInsert = () => {
    if (!editor || !canInsert) return;

    editor
      .chain()
      .focus()
      .insertFormField({
        value: "",
        placeholder: t("RICH_EDITOR_TOOLBAR_FORM_FIELD_FIELD_TOOLTIP"),
      })
      .run();
    onInserted?.();
  };

  return {
    isVisible,
    canInsert,
    isActive,
    handleInsert,
    label: "RICH_EDITOR_TOOLBAR_FORM_FIELD_BUTTON_TOOLTIP",
    Icon: undefined,
  };
};
